import { request } from "./client";
import type {
  ManualAdjustmentInput,
  TimeEventCorrectionInput,
  TimeEventResponse,
  WorkerEventInput,
} from "./types";

/** POST /api/v1/tawa/timeevents/{id}/correct — manual correction with reason. */
export async function correctTimeEvent(
  eventId: string,
  body: TimeEventCorrectionInput,
): Promise<TimeEventResponse> {
  return request<TimeEventResponse>({
    method: "POST",
    url: `/timeevents/${encodeURIComponent(eventId)}/correct`,
    data: body,
  });
}

/**
 * POST /api/v1/tawa/timeevents — create a fresh time_event from manager/admin
 * to fill a gap (worker forgot to badge). Reason is mandatory.
 */
export async function createManualAdjustment(
  body: ManualAdjustmentInput,
): Promise<TimeEventResponse> {
  return request<TimeEventResponse>({
    method: "POST",
    url: "/timeevents",
    data: body,
  });
}

/**
 * POST /api/v1/tawa/workers/timeevents — un worker crée un event sur SA PROPRE
 * timesheet draft (insertion / ajout libre). worker_url forcé au principal côté
 * serveur. La raison est obligatoire.
 */
export async function createWorkerEvent(
  body: WorkerEventInput,
): Promise<TimeEventResponse> {
  return request<TimeEventResponse>({
    method: "POST",
    url: "/workers/timeevents",
    data: body,
  });
}
